




















































import { Vue, Component, Watch, } from "@/shared/vuepack";
import { AuthType } from "@/shared/types";
import { Validator } from "vee-validate";
import { Location } from "vue-router";
import { mergeReturnUrl } from "@/shared/loginNavigation";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";

const CognitoSubmitMessage = "If you entered an email address associated with a valid Bend account you will be sent a verification code to that address.";
const OktaSubmitMessage = "If you entered a username associated with a valid account you will be sent a temporary password to the email address on file.";

const lowercase = (value: any) => {
  return typeof value === "string"
      ? value.toLowerCase()
      : value;
};

@Component({
  components: {
    LoginWrapper,
    Button,
    Input
  },
  props: {
    routeToForgotPasswordVerify: null,
    routeToLogin: null
  },
  filters: {
    lowercase
  }
})
export default class LoginForgotPassword extends Vue {
  $validator: Validator;

  notifierStore = useNotifierStore();
  userStore = useUserStore();

  isSubmitting = false;
  routeToForgotPasswordVerify: (user: string) => Location;
  routeToLogin: Location;
  email = "";

  get authType () {
    return this.$route.query && this.$route.query.authType
        ? this.$route.query.authType
        : AuthType.Cognito;
  }

  get isOktaAuth () {
    return this.authType === AuthType.Okta;
  }

  get verificationMethod () {
    return this.authType === AuthType.Okta ? "Temporary Password" : "Verification Code";
  }

  get loginRoute (): Location {
    return this.routeToLogin;
  }

  mounted () {
    if (this.userStore.cognitoDR) {
      this.email = this.userStore.user.email;
    }
  }

  @Watch("userStore.cognitoDR")
  onCognitoDisasterRecoveryDetected (newValue) {
    if (newValue) {
      this.notifierStore.setSuccess("You have received a new password at your email on file.");
    }
    this.$router.push(this.routeToLogin);
  }

  onSubmit () {
    if (this.isSubmitting) return;

    this.$validator.validateAll()
        .then(result => {
          if (result) {
            this.onValidSubmit();
          }
        });
  }

  onValidSubmit () {
    this.isSubmitting = true;
    this.email = this.email.toLowerCase();
    this.userStore.resetPassword({ username: this.email, authType: this.authType })
        .then(() => {
          if (this.userStore.cognitoDR) return;

          const message = this.getSubmitMessage();
          const nextRouteLocation = this.getNextRouteLocation();
          this.$router.push(nextRouteLocation);

          // changing routes wipes notifications, so we need to wait for the next route to load
          // before displaying this to the user
          this.$nextTick(() => this.notifierStore.setSuccess(message));
        })
        .catch(err => {
          this.onResetPasswordError(err);
        });
  }

  getNextRouteLocation () {
    // okta forgot password flow sends a temporary password to a user
    // redirecting to a login page so that a user can login with a temp password
    if (this.isOktaAuth) {
      return mergeReturnUrl(this.$route, this.routeToLogin);
    }

    const nextRouteLocation = this.routeToForgotPasswordVerify(this.email);
    return mergeReturnUrl(this.$route, nextRouteLocation);
  }

  onResetPasswordError (err) {
    this.isSubmitting = false;
  }

  get submitDisabled () {
    return this.isSubmitting === true;
  }

  getSubmitMessage () {
    return this.authType === AuthType.Okta
        ? OktaSubmitMessage
        : CognitoSubmitMessage;
  }
}
